import React from 'react';
import { Sparkles, Clock, Zap } from 'lucide-react';
export function MechanismSection() {
  return <section className="py-20 bg-brand-dark text-white relative overflow-hidden" data-id="element-131">
      {/* Decorative elements */}
      <div className="absolute top-0 right-0 w-64 h-64 bg-brand-gold/10 rounded-full blur-3xl transform translate-x-1/2 -translate-y-1/2" data-id="element-132"></div>
      <div className="absolute bottom-0 left-0 w-96 h-96 bg-brand-gold/5 rounded-full blur-3xl transform -translate-x-1/2 translate-y-1/2" data-id="element-133"></div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-134">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-135">
          <span className="text-brand-gold font-bold tracking-wider uppercase text-sm mb-4 block" data-id="element-136">
            La Solución Científica
          </span>
          <h2 className="font-serif text-3xl md:text-5xl font-bold mb-6 text-brand-cream" data-id="element-137">
            Presentando: La Pausa Enzimática
          </h2>
          <p className="text-xl text-gray-300 font-light" data-id="element-138">
            Un protocolo simplificado para la mujer moderna que no tiene tiempo
            para menús complicados.
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-8" data-id="element-139">
          <div className="bg-white/5 backdrop-blur-sm p-8 rounded-2xl border border-white/10 hover:border-brand-gold/50 transition-colors" data-id="element-140">
            <div className="w-14 h-14 bg-brand-gold/20 rounded-xl flex items-center justify-center mb-6 text-brand-gold" data-id="element-141">
              <Clock className="h-7 w-7" data-id="element-142" />
            </div>
            <h3 className="text-xl font-bold mb-4 font-serif text-brand-cream" data-id="element-143">
              Descanso Digestivo
            </h3>
            <p className="text-gray-400 leading-relaxed" data-id="element-144">
              Le damos a tu sistema digestivo un respiro estratégico de ciertos
              alimentos inflamatorios durante 7 días, permitiendo que la pared
              intestinal se repare.
            </p>
          </div>

          <div className="bg-white/5 backdrop-blur-sm p-8 rounded-2xl border border-white/10 hover:border-brand-gold/50 transition-colors" data-id="element-145">
            <div className="w-14 h-14 bg-brand-gold/20 rounded-xl flex items-center justify-center mb-6 text-brand-gold" data-id="element-146">
              <Zap className="h-7 w-7" data-id="element-147" />
            </div>
            <h3 className="text-xl font-bold mb-4 font-serif text-brand-cream" data-id="element-148">
              Activación Metabólica
            </h3>
            <p className="text-gray-400 leading-relaxed" data-id="element-149">
              Al reducir la inflamación, tu cuerpo sale del "modo supervivencia"
              y vuelve a priorizar la quema de energía y la regulación hormonal
              natural.
            </p>
          </div>

          <div className="bg-white/5 backdrop-blur-sm p-8 rounded-2xl border border-white/10 hover:border-brand-gold/50 transition-colors" data-id="element-150">
            <div className="w-14 h-14 bg-brand-gold/20 rounded-xl flex items-center justify-center mb-6 text-brand-gold" data-id="element-151">
              <Sparkles className="h-7 w-7" data-id="element-152" />
            </div>
            <h3 className="text-xl font-bold mb-4 font-serif text-brand-cream" data-id="element-153">
              Claridad Mental
            </h3>
            <p className="text-gray-400 leading-relaxed" data-id="element-154">
              La conexión intestino-cerebro es real. Al desinflamar tu abdomen,
              notarás cómo desaparece la neblina mental y recuperas tu enfoque.
            </p>
          </div>
        </div>
      </div>
    </section>;
}